import React from 'react';
import './DataBreakdown.scss';

const WsDataBreakdown = (props: any) => {
  return (
    <div>
      <div className='page-heading'>Data Breakdown</div>
      <hr />
      <div className='placeholder-txt'>Placeholder Page...</div>
    </div>
  );
};

export { WsDataBreakdown };
